import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useGetCallbackQuery } from "reduxFiles/api/licenseApi";

const PaymentCallbackPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const transId = searchParams.get("trans_id");
  const id = searchParams.get("id_get");

  const { data, isLoading, isError, refetch } = useGetCallbackQuery(
    {
      transId: Number(transId),
      id: Number(id),
    },
    {
      skip: !transId || !id,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data?.redirectUrl) {
      window.location.href = data.redirectUrl;
    }
  }, [data, navigate]);

  if (!transId || !id) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-yellow-100">
            <span className="text-2xl">⚠️</span>
          </div>
          <h2 className="mb-2 text-xl font-bold text-gray-800">
            {t("paymentCallback.invalidParams.title")}
          </h2>
          <p className="mb-6 text-gray-600">
            {t("paymentCallback.invalidParams.description")}
          </p>
          <button
            onClick={() => (window.location.href = "/app")}
            className="rounded-lg bg-blue-600 px-6 py-2.5 text-white transition-colors hover:bg-blue-700"
          >
            {t("paymentCallback.invalidParams.button")}
          </button>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
          <div className="mb-6 flex justify-center">
            <div className="loader w-8 text-brand-500"></div>
          </div>
          <h3 className="text-lg font-semibold text-gray-800">
            {t("paymentCallback.loading.title")}
          </h3>
          <p className="mt-2 text-sm text-gray-500">
            {t("paymentCallback.loading.description")}
          </p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <span className="text-2xl">❌</span>
          </div>
          <h3 className="mb-2 text-lg font-semibold text-gray-800">
            {t("paymentCallback.error.title")}
          </h3>
          <p className="mb-6 text-sm text-gray-600">
            {t("paymentCallback.error.description")}
          </p>
          <div className="flex items-center gap-2">
            <button
              onClick={refetch}
              className="w-full rounded-lg bg-blue-600 px-6 py-2.5 text-white transition-colors hover:bg-blue-700"
            >
              {t("paymentCallback.error.button")}
            </button>
            <button
              onClick={() => (window.location.href = "/app")}
              className="rounded-lg bg-red-600 px-6 py-2.5 text-white transition-colors hover:bg-red-700"
            >
              {t("paymentCallback.invalidParams.button")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        <div className="mb-6 flex justify-center">
          <div className="loader w-8 text-brand-500"></div>
        </div>
        <h3 className="text-lg font-semibold text-gray-800">
          {t("paymentCallback.loading.title")}
        </h3>
      </div>
    </div>
  );
};

export default PaymentCallbackPage;
